import React from 'react';
import {Alert, Box, Stack} from '@mui/material';
import {designSystemToken, Icon, Label} from '@lightricks/react-design-system';
import translate from '@/utils/translate';

function MainErrorDisplay({
  errorAmount,
  onClear,
  isOpen,
  setIsOpen,
}: {
  errorAmount: number;
  onClear: () => void;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}) {
  return (
    <Alert
      icon={
        <Icon
          name="Navigation-Notification"
          size="large"
          appearance="primary"
        />
      }
      sx={{
        'display': 'flex',
        'alignItems': 'center',
        'justifyContent': 'flex-start',
        'width': '472px',
        'backgroundColor': designSystemToken('semantic.bg.secondary'),
        'borderRadius': '16px',
        'boxShadow': '0px 4px 16px 0px rgba(0, 0, 0, 0.1)',
        '& .MuiAlert-message': {
          overflow: 'hidden',
        },
      }}
    >
      <Stack direction="row" alignItems="center" sx={{width: '430px'}}>
        <Label size="md">
          {translate('notifications', {
            notifications: errorAmount,
            count: errorAmount,
          })}
          &nbsp;
        </Label>
        <Label
          size="md"
          color={designSystemToken('semantic.fg.secondary')}
          sx={{
            cursor: 'pointer',
            textDecoration: 'underline',
          }}
          onClick={onClear}
        >
          {translate('clear')}
        </Label>
        <Box
          sx={{marginLeft: 'auto', cursor: 'pointer'}}
          onClick={() => setIsOpen(!isOpen)}
        >
          <Icon
            name={
              isOpen ? 'Actions-Arrow-Up-Small' : 'Actions-Arrow-Down-Small'
            }
            size="large"
            appearance="primary"
          />
        </Box>
      </Stack>
    </Alert>
  );
}

export default MainErrorDisplay;
